/* eslint-disable @typescript-eslint/no-explicit-any */
export class HandledError extends Error {
  context: any = {}
  constructor(message: string, context?: any) {
    super(message)
    this.context = context
  }
}

export function isHandledError(error: unknown): error is HandledError {
  return error instanceof HandledError
}
